import { bankApi } from "./authenticatedAxios";

export const loginNotificationApi = () => bankApi.post(`/notification/login`).then(({ data }) => data);
